<template>
  <div>
    <div v-if="isPC" class="product-list">
      <!-- 品类+筛选 -->
      <div class="filter">
        <div class="navigation">
          <span class="pointer" @click="$router.replace('/')">{{ $t('Index.Similar.Home') }}</span>
          <i class="iconfont icon-a-arrow-left-s-line2"></i>
          <span style="color:#8B93A3;">{{ $t('Index.Similar.VisualSearch') }}</span>
          <span style="padding-left: 20px;">{{ similarList.length }} {{ $t('Index.Similar.Products') }}</span>
        </div>
        <div class="img-box">
          <photograph>
            <div class="img" :title="$t('Index.Similar.UploadAPicture')">
              <img v-if="imgUrl" :src="imgUrl" alt="">
              <div v-else class="empty">
                <i class="iconfont icon-zhaopian" />
                <div>{{ $t('Index.Similar.Tips1') }}</div>
                <div style="font-size:12px;color: #747A87;">{{ $t('Index.Similar.Tips2') }}</div>
              </div>
              <div class="camera f-c-c">
                <i class="iconfont icon-photo"></i>
              </div>
            </div>
          </photograph>
        <div class="f-c-c" style="margin-top:10px">
          <el-button round @click="$router.push('/customizedAdd')">{{ $t('Index.Similar.INeedCustomization') }}</el-button>
        </div>
        <div class="f fw-w" style="margin-top:10px" v-if="show">
          <div v-for="(item,index) in similar_imgList" style="width:64px;" :key="index" class="similar-img pointer" @click="changeCurrentSimilarImg(item)" >
            <oss-img :src="item" :width="32" :height="48" style="width:100%;border-radius: 6px;" />
          </div>
        </div>
        </div>
      </div>

      <!-- 商品列表 -->
      <div class="product-box">
        <div v-if="similarList.length || loading" >
          <div class="product-list f-b" v-loading="loading" element-loading-text="Searching">
            <product-item v-for="item in similarList" :key="item.kkProductId" :product="item"></product-item>
            <div v-for="i in 3" :key="i" class="empty-product"></div>
          </div>
        </div>
        <div v-else>
          <product-empty style="margin: 20px auto" />
        </div>
      </div>
    </div>
    <div v-else class="mobile-similar">
      <photograph>
        <div class="upload-img">
          <img v-if="imgUrl" :src="imgUrl" alt="">
          <div class="camera f-c-c">
            <i class="iconfont icon-photo"></i>
          </div>
        </div>
      </photograph>
      <!-- 商品列表 -->
      <div class="product-box">
        <div v-if="similarList.length || loading">
          <div class="list f-b" v-loading="loading">
            <product-item v-for="item in similarList" :key="item.kkProductId" :product="item"></product-item>
            <div class="empty-product"></div>
          </div>
        </div>
        <div v-else>
          <product-empty class="product-empty" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Photograph from './components/Photograph.vue'
import API from '@/api'
// import _ from 'lodash'
import Product from '@/components/Product.vue'
import ProductEmpty from './components/ProductEmpty.vue'
import bus from '@/util/bus.js'

// 压缩图片插件
// import ImageCompressor from 'js-image-compressor'

export default {
  components: {
    'product-item': Product,
    ProductEmpty,
    Photograph
  },
  data() {
    return {
      imgUrl: sessionStorage.getItem('similar_base64') ? sessionStorage.getItem('similar_base64') : sessionStorage.getItem('similar_img'),
      similarList: [],
      loading: false,
      similar_imgList: [],
      show: true
    }
  },

  created() {
    bus.$on('getStorage', this.getStorage)
    // 从商品详情跳转过来
    if (this.$route.query.kkProductId) {
      const { color, imgUrl, kkProductId } = this.$route.query
      this.imgUrl = imgUrl
      API.searchProductSimilarImgList({
        color, imgUrl, kkProductId
      }).then(res => {
        this.similarList = res.data.imgData
      })
      // this.similarList = this.$store.state.productDetailSimilar
      return
    } else if (!this.isPC) {
      !this.loading && this.searchImage()
    }
    this.getSimilarImage()
  },
  activated() {
    if (!this.loading && !this.$route.query.kkProductId) this.searchImage()
  },
  methods: {
    // 获取最近以图搜图图片
    getSimilarImage() {
      API.getUserBehavior({ type: 3 }).then(res => {
        let data = res.data ? res.data.split(',') : []
        if (data.length > 0) {
          this.similar_imgList = data.slice(1)
        }
        localStorage.setItem('similar_imglist', JSON.stringify(data))
      })
    },
    getStorage() {
      // const imageFile = this.convertFile()
      // this.imageCompressorHandle(imageFile)
      this.loading = true
      this.searchImage()
    },
    changeCurrentSimilarImg(item) {
      sessionStorage.removeItem('similar_base64')
      sessionStorage.setItem('similar_img', item)
      this.searchImage()
    },

    searchImage() {
      this.imgUrl = sessionStorage.getItem('similar_base64') ? sessionStorage.getItem('similar_base64') : sessionStorage.getItem('similar_img')
      this.searchImageList(sessionStorage.getItem('similar_img'))
      let arr = localStorage.getItem('similar_imglist') && localStorage.getItem('similar_imglist') !== undefined ? JSON.parse(localStorage.getItem('similar_imglist')) : []
      let str = sessionStorage.getItem('similar_img')
      this.show = str.indexOf('zhiyi') === -1
      if (!arr.includes(str) && str.indexOf('zhiyi') === -1) {
        arr.unshift(sessionStorage.getItem('similar_img'))
        arr = arr.slice(0, 7)
        localStorage.setItem('similar_imglist', JSON.stringify(arr))
        this.setSimilarImage(arr)
      }
    },
    setSimilarImage(data) {
      API.setUserBehavior({ type: 3, content: data.toString() }).then(res => {
        setTimeout(() => {
          this.getSimilarImage()
        }, 300)
      })
    },

    // // base64转文件
    // convertFile() {
    //   let dataurl = sessionStorage.getItem('similar_img')
    //   let arr = dataurl.split(',')
    //   let mime = arr[0].match(/:(.*?);/)[1]
    //   let bstr = atob(arr[1])
    //   let n = bstr.length
    //   let u8arr = new Uint8Array(n)
    //   while (n--) {
    //     u8arr[n] = bstr.charCodeAt(n)
    //   }
    //   return new File([u8arr], 'image', { type: mime === 'image/webp' ? 'image/jpeg' : mime })
    // },

    // // 图片压缩
    // imageCompressorHandle(file) {
    //   const self = this
    //   new ImageCompressor({
    //     file,
    //     quality: 0.8, // 压缩质量
    //     width: 280,
    //     height: 330,
    //     success(result) {
    //       self.customProductGetSignValue(result)
    //     }
    //   })
    // },

    // // 获取阿里云文件服务器上传校验秘钥
    // customProductGetSignValue(result) {
    //   API.customProductGetSignValue({ directory: 'baidusimilar/' }).then(({ data }) => {
    //     this.customProductUploadFile(data, result)
    //   })
    // },

    // // 图片上传
    // customProductUploadFile(data, result) {
    //   // console.log(data, result)
    //   const formData = new FormData()
    //   formData.append('directory', 'baidusimilar/')
    //   formData.append('signValue', data)
    //   formData.append('fileList', result)
    //   this.loading = true
    //   API.customProductUploadFile(formData).then(({ data }) => {
    //     this.searchImageList(data)
    //   })
    // },

    // 获取产品列表（以图搜图）
    searchImageList(imageFileUrl) {
      this.loading = true
      this.similarList = []
      API.searchImageList({ imageFileUrl }).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.similarList = res.data
      }).finally(() => {
        this.loading = false
      })
    }
  },
  beforeDestroy() {
    bus.$off('getStorage')
  }
}
</script>

<style lang="scss" scoped>
.product-list{
  max-width: 1420px;
  min-width: 1000px;
  padding: 0 15px;
  margin: 0 auto;

  /deep/ .el-loading-mask{
    background-color: unset;
  }

  .filter {
    width: 350px;
    position: fixed;
    // background: #FFFFFF;
    overflow: hidden;

    .navigation{
      line-height: 50px;
    }

    .img-box {
      width: 250px;
      padding: 16px;
      background-color: #fff;
    }

    .img {
      width: 218px;
      height: 328px;
      border: 1px solid #eee;
      border-radius: 12px;
      position: relative;
      border: 1px dashed #d9d9d9;;

      >img {
        object-fit: cover;
        width: 100%;
        height: 100%;
        border-radius: 6px;
      }

      .camera {
        width: 38px;
        height: 30px;
        background: rgba(0, 0, 0, 0.75);
        border-radius: 6px;
        position: absolute;
        bottom: 18px;
        left: 0;
        right: 0;
        margin: auto;

        .iconfont {
          color: #fff;
        }
      }

      .empty{
        text-align: center;

        i {
          font-size: 180px;
          color: #CDD4DD;
        }

        >div {
          width: 160px;
          margin: 0 auto;
          line-height: 24px;
        }
      }
    }
  }
  .product-box{
    padding-left: 280px;
    padding-top: 50px;
    width: 100%;
    height: 840px;

    .product-list {
      flex-wrap: wrap;
      padding-bottom: 40px;

      >div {
        width: 22%;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.mobile-similar {
  padding: .4rem .3rem;
  box-sizing: border-box;

  .upload-img {
    width: 1.5rem;
    height: 2.1rem;
    margin: 0 auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: .12rem;
    }

    .camera {
      width: .56rem;
      height: .4rem;
      background: rgba(0, 0, 0, 0.75);
      border-radius: .12rem;
      position: absolute;
      bottom: .08rem;
      left: 0;
      right: 0;
      margin: auto;

      .iconfont {
        color: #fff;
      }
    }
  }

  /deep/.box {
    margin: 1.2rem auto;
    img{
      width: 4.24rem;
      height: 3.2rem;
    }
  }

  .list {
    flex-wrap: wrap;
    margin-top: .4rem;

    >div {
      width: 48%;
      margin-bottom: .1rem;
    }
  }
}
.similar-img{
  margin-right: 12px!important;
}
.similar-img:nth-child(3n){
  margin-right: 0!important;
}
</style>
